/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Sunday, May 29th 2022, 2:22:14 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import React from "react";
import { useRouteQueryParams } from "core/routes/utils";
import { useAPIGoogleSignIn } from "authentication/services/OAuthAPI";
import { useNavigate } from "react-router-dom";
import { URLS } from "core/routes";
import { CircularProgressCentered } from "ui-widgets/progress/CustomLoaders";
import { GoogleSignInError } from "./GoogleSignInError";

export const AdminSSOCallback = () => {
  const { isSigningInToGoogle, isFetchingUserDetails, isAPIError, errorMessage } = useAdminSSOCallback();

  return isSigningInToGoogle || isFetchingUserDetails || !isAPIError ? (
    <CircularProgressCentered />
  ) : isAPIError ? (
    <GoogleSignInError errorMessage={errorMessage} />
  ) : null;
};

const useAdminSSOCallback = () => {
  const queryParams = useRouteQueryParams();
  const googleAuthCode = queryParams.get("code");

  const navigate = useNavigate();

  const { googleSignInResponse, isSigningInToGoogle, isFetchingUserDetails, loggedInUser, isAPIError, errorMessage } =
    useAPIGoogleSignIn(googleAuthCode);

  React.useEffect(() => {
    if (googleSignInResponse?.signup_required) navigate(URLS.adminSSOSignUp); // Redirect to sign up. Backend by now, has stored google details in session, so we need not worry about that. Let the backend do its job. Single Responsibility principle.

    if (loggedInUser?.id) navigate(URLS.dashboard); // Backend has logged in the user. We have a session!!
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [googleSignInResponse?.signup_required, loggedInUser?.id]);

  return { isSigningInToGoogle, isFetchingUserDetails, isAPIError, errorMessage };
};
